<template>
  <div class="page">
    <div ref="chartDom" class="bar" id="chartOne" style="width: 600px;height: 600px;border:2px solid red"></div>
  </div>
</template>

<script>

export default{
	mounted() {
		this.getEcharts3DBar();
	},
	methods: {
		 getEcharts3DBar() {
			let xdata =[
    2014,
    2015,
    2016,
    2017,
    2018,
    2019,
    2020,
    2021,
    2022
],
lineData = [
    0,
    -2.01,
    17.18,
    -5.73,
    -4.48,
    13.73,
    16.94,
    6.77,
    12.77
],barData=[
    1349.4,
    1322.21,
    1549.43,
    1460.7,
    1395.33,
    1586.87,
    1855.74,
    1981.41,
    2234.39
],legendName='fdsalfjl dd',unit='%';
			 		var mychart = echarts.init(document.getElementById('chartOne'));
			 		  let min = Math.floor(Math.min(...barData));
			 		  let max = Math.floor(Math.max(...barData));
			 		  let lineMin = Math.floor(Math.min(...lineData));
			 		  let lineMax = Math.floor(Math.max(...lineData));
			 		  let barWidth = 40;
			 		  let range = max - min;
			 		  console.log(min,max,range);
			 		  // return barData.map(value => (value - min) / range * (100 - 2) + 1);
			 	      const option = {
			 	        tooltip: {
			 	          trigger: 'axis',
			 	          axisPointer: {
			 	              type: 'shadow'
			 	          },
			 			  grid: {
			 			          top:'100%',
			 			          // containLabel: true // 包含标签
			 			      },
			 			  // confine:true, //是否将提示框限制在图表的区域内
			 			 appendToBody: true, //是否将提示框放置在body元素上
			 			formatter: function(params) {
			 				// console.log(params);
			 				var result = ''
			 				var name = params[0].name +"</br>";
			 				var dotHtml='',dotHtml2='',unitd = params[0].componentSubType=="line"?' %':unit;
			 				if(params[0]){
			 					dotHtml ='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+params[0].color +'"></span> '+params[0].seriesName+"： " + params[0].data+' '+unitd + "</br>"; // 定义第一个数据前的圆点颜色	
			 				}
			 				if(params[1]){
			 					dotHtml2='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+params[1].color + '"></span>'+params[1].seriesName+"： " + params[1].data+' %';
			 				}
			 				  
			 				result += name + dotHtml + dotHtml2;
			 				return result
			 			},
			 	        },
			 			legend: {
			 				show: true,
			 				bottom:"5%",
			 			},
			 	        xAxis: {
			 	          type: 'category',
			 	          data: xdata,
			 	          interval: 0,
			 			  axisLine:{
			 				  onZero:false,
			 			  }
			 	          // axisLabel: { color: '#333', interval: 0, rotate: 50 }
			 	        },
			 	        yAxis:[
			 				{
			 					type: 'value',
			 					name: '',
			 					minInterval:1,
			 					min:min,
			 					// boundaryGap: false,
			 					// step:
			 					axisTick: {
			 						"show": true
			 					},
			 					axisLine: {
			 						show: true,
			 					}, //显示y轴刻度线
			 					splitLine: {
			 						show: false
			 					}, //不显示分割线
			 				},
			 				{
			 					type: 'value',
			 					name: ' ',
			 					min:lineMin,
			 					 // boundaryGap: false,
			 					axisTick: {
			 						"show": true
			 					},
			 					splitLine: {
			 						show: false
			 					}, //不显示分割线
			 					axisLine: {
			 						show: true,
			 					}, //显示y轴刻度线
			 					axisLabel: {
			 						// 使用 formatter 属性来格式化标签文本
			 						formatter: '{value} %' // 在这里添加单位
			 					}
			 				}
			 			] ,
			 	        series: [
			 				
			 				      // 产值中间正方形
			 				      {
			 				        type: "pictorialBar",
			 				        symbol: "diamond",
			 				        symbolSize: [barWidth, 8],
			 				        symbolOffset: [9, -4.5],
			 				        symbolPosition: "end",
			 				        z: 12,
			 				        color: "rgb(60, 135, 255)",
									yAxisIndex: 0,
			 				        data: barData,
			 				      },
			 				      // 产值进度柱子
			 				      {
			 				        name: "计划产值",
			 				        type: "bar",
			 				        barWidth: barWidth,
			 				        stack: "1",
			 				        itemStyle: {
			 				          normal: {
			 				            // opacity: 0.7,
			 				            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
			 				              {
			 				                offset: 0,
			 				                color: "rgb(84,128,191)",
			 				              },
			 				              {
			 				                offset: 1,
			 				                color: "rgb(84,128,191)",
			 				              },
			 				            ]),
			 				            barBorderRadius: 0,
			 				          },
			 				        },
			 				        label: {
			 				          show: true,
			 				          position: ["-18", "-18"],
			 				          color: "rgb(84,128,191)",
			 				          fontSize: 12,
			 				        },
									yAxisIndex: 0,
			 				        data: barData,
			 				      },
			 				      // 产值进度柱子
			 				      {
			 				        name: "中间的线",
			 				        type: "bar",
			 				        barWidth: 0.5,
			 				        barGap: "-48%",
			 				        itemStyle: {
			 				          normal: {
			 				            // opacity: 0.7,
			 				            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
			 				              {
			 				                offset: 0,
			 				                color: "#ffffff",
			 				              },
			 				              {
			 				                offset: 1,
			 				                color: "#161D6E",
			 				              },
			 				            ]),
			 				          },
			 				        },
									yAxisIndex: 0,
			 				        data: barData,
			 				      },
			 				    
			 			// 	{
			 	  //           type: 'bar',
			 			// 	name: legendName + (this.pageType==2?'':'('+unit+')'),
			 			// 	color: 'rgb(96, 147, 218)',
			 			// 	yAxisIndex: 0, // 这里指定使用第一个 Y 轴
			 	  //           data:  barData,
			 	  //       },
			 			{
			 				name: 'YOY',
			 				type: 'line',
			 				yAxisIndex: 1,
			 				color: '#ffaf25',
			 				data:  lineData
			 			}
			 			]
			 	      }
			 	       mychart.setOption(option)
			 	    
			 
		 }
	},
}


</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  .bar {
    width: 800px;
    height: 800px;
  }
}
</style>

